import React, {useState} from "react";
import api from "../../../services/api";
import {toast} from "react-toastify";
import messageTypes from "../../../constants/MessagesTypes";
import i18n from "../../../services/i18n";
import ConfirmDeleteModal from "../../ConfirmDeleteModal";

function AlertDelete({
   title = i18n.t('alert_confirm_title'),
   text = i18n.t('alert_delete_text'),
   notice,
   urlCallback,
   functionCallbackCancel = null,
   functionCallbackConfirm = null,
   urlDelete,
   setSuccessDelete = () => {}
}) {
    const [open, setOpen] = useState(true);
    const [loading, setLoading] = useState(false);

    function handleClose() {
        setOpen(false);
        setSuccessDelete(null);
        if (functionCallbackCancel) {
            functionCallbackCancel();
        }
    }

    async function handleConfirm() {
        setLoading(true);
        try {
            await api.delete(urlDelete, {
                headers: {
                    'Content-Type': 'application/json',
                    auth: true,
                },
            });
            toast.success(messageTypes.SUCCESS);
            if (urlCallback) {
                window.location.href = urlCallback;
            } else if (setSuccessDelete) {
                setSuccessDelete(true);
            }
            if (functionCallbackConfirm) {
                functionCallbackConfirm();
            }
            setOpen(false);
        } catch (exception) {
            setSuccessDelete(false);
            toast.error(i18n.t('alert_error_delete'));
        } finally {
            setLoading(false);
        }
    }

    return (
        <ConfirmDeleteModal
            isOpen={open}
            onClose={handleClose}
            onConfirm={handleConfirm}
            title={title}
            message={text}
            notice={notice}
            loading={loading}
        />
    );
}

export default AlertDelete;
